import React from 'react';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import { Col, Row } from 'react-bootstrap';
import VerticalNavigation from '../navigation/vertical-navigation';
import RolesViewUserActivationCard from './roles-view-user-activation-card';
import RolesInfoCard from './roles-info-card';

export interface Props {}

function RolesOverviewWrapper(props: Props) {
    return (
        <Navbar nav>
            <Row>
                <LeftSide addClass="">
                    <VerticalNavigation selected="roles" />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <RolesViewUserActivationCard />
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <RolesInfoCard />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Navbar>
    );
}

export default RolesOverviewWrapper;
